'use client';
import { css } from 'styled-system/css'
import { flex, grid } from 'styled-system/patterns';

export const styles = {
	balanceInfo: css({
		position: 'absolute',
		top: 'var(--header-height)',
		left: 0,
		right: 0,
		display: 'flex',
		flexDirection: 'column',
		color: 'black.1',
		backgroundColor: 'var(--other-lv2)',
		padding: '9px 6px',
		gap: '9px',
		boxShadow: '0px 10px 10px 0px rgba(0, 0, 0, 0.19)',
		borderBottomLeftRadius: '6px',
		borderBottomRightRadius: '6px',
		md: {
			display: 'none',
		},
	}),

	switch: css({
		display: 'flex',
		alignSelf: 'flex-end',
		gap: '6px',
	}),
	switchText: css({
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '18px',
	}),
	switchBtn: css({
		flex: 'none',
		backgroundColor: 'black.3',
		borderRadius: '30px',
		display: 'flex',
		width: '40px',
		height: '20px',
		padding: '2px',
		alignItems: 'center',
		transition: 'background-color .3s',
		'&[data-active=true]': {
			backgroundColor: 'brand.500',
		}
	}),
	switchDot: css({
		display: 'inline-block',
		backgroundColor: 'white',
		borderRadius: '100em',
		width: '16px',
		height: '16px',
		position: 'relative',
		left: 0,
		transition: 'left .3s',
		'[data-active=true] >&': {
			left: 'calc(100% - 16px)',
		}
	}),
	list: css({
		display: 'flex',
		flexDirection: 'column',
		borderRadius: '6px',
		color: 'black.2',
		border: '1px solid {colors.black.5}',
		fontSize: '14px',
		lineHeight: '15px',
		fontWeight: '500',
	}),
	listItem: grid({
		gridTemplateColumns: '1fr 1fr',
		alignItems: 'center',
		gap: '3px',
		padding: '6px 0',
		margin: '0 9px',
		'& + &': {
			borderTop: '1px solid {colors.black.5}',
		}
	}),
	heading: css({
		fontWeight: '700',
	}),
	title: css({
		gridColumn: '1 / 2',
		gridRow: '1 / 3',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	}),
	currency: css({
		textAlign: 'right',
		color: 'black.3',
	}),
	value: flex({
		gridColumn: '2 / 3',
		flex: 'none',
		justifyContent: 'flex-end',
		textAlign: 'right',
		fontSize: '16px',
	}),
	icon: css({
		flex: 'none',
		marginRight: '6px',
	}),
}


